<template>
    <div class="runtime_cont">
        <div class="runtime_box">
            <div class="time_top">
                <div class="numbox">
                    <span class="time_text">Module Running Duration：</span>
                    <span class="time_num">{{ runtime }}</span>
                </div>
            </div>
            <div class="time_down">
                <span>AI Model ID：{{ allControlData.result.AI_ID }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import maincharts from "./charts/maincharts";

export default {
    components: {
        maincharts,
    },
    data() {
        return {
            show: true,
            allControlData: {
                result: {
                    AI_ID: null
                }
            },
            openIndex: null,
            choseid: 0,
            chartData: null,
            bigchartdata: null,
            activeName: null,
            timer: null,
            runtime: null
        };
    },

    watch: {

    },
    mounted() {
        this.openIndex = this.$route.query.index;
        this.getall(this.openIndex);
        this.getControlData(this.openIndex);
    },
    methods: {
        choseitem(item) {
            this.choseid = item.id

        },
        async getall(index) {
            const { data: res } = await this.$http.get("/modules/runtime", {
                params: { index: index },
            });
            // console.log(res);
            this.modellist = res.data;
            this.runtime = this.modellist.result.AI控制时间.总计
            this.modellist.chartdata = [
                {
                    name: "人工控制时间",
                    value: parseFloat(this.modellist.result.人工控制时间.占比),
                    number: this.modellist.result.人工控制时间.总计
                },
                {
                    name: "AI控制时间",
                    value: parseFloat(this.modellist.result.AI控制时间.占比),
                    number: this.modellist.result.AI控制时间.总计
                },
            ];
        },
        cbrBtnStyle(index) {
            if (this.allControlData.result.pool[index].flag == true) {
                return { backgroundColor: "#1890ff", color: "fff" };
            } else {
                return { backgroundColor: "#b8b8b8", color: "fff" };
            }
        },
        async getControlData(index) {
            const { data: res } = await this.$http.get("/modules/init", {
                params: { index: index },
            });
            this.allControlData = res.data;
            console.log(this.allControlData);
        },
        changeChart(item) {
            console.log(item);
            this.bigchartdata = item;
            console.log(item);
        },
        handleClick(tab, event) {
            this.changeChart(this.chartData[tab.index].data[0])

        },
    },
};
</script>

<style lang="scss" scoped>
h4 {}

.runtime_cont {
    .runtime_box {
        left: 1992.9px;
        top: 1128.4px;
        width: 466.7px;
        height: 134.6px;
        opacity: 1;
        border-radius: 22.1px;
        background: #212121FF;
        box-shadow: 0px 2.6px 9.1px rgba(0, 0, 0, 0.05);

        .time_top {
            // text-align: center;
            margin-left: 27px;
            max-width: 410px;
            border-bottom: 1px solid #525252FF;

            .numbox {
                padding-top: 17px;
                padding-bottom: 17px;
                // margin-left: 30px;

                .time_text {
                    // margin-top: 21px;
                    font-size: 18.2px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 24.38px;
                    color: #C5C5C5FF;
                }

                .time_num {
                    font-size: 20.8px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 24.38px;
                    color: #40E0D0FF;
                    // color: rgba(39, 111, 183, 1);
                    text-align: left;
                    vertical-align: top;
                }
            }
        }

        .time_down {
            margin-top: 17px;
            margin-left: 27px;
            // text-align: center;
            font-size: 18.2px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 21.33px;
            color: #C5C5C5FF;
            text-align: left;
            // vertical-align: top;
        }
    }
}
</style>
